<template>
  <div>
    <el-tooltip
      content="Цель является блокирующей. При выполнении цели менее, чем на 50% общая премия обнуляется"
      placement="top"
      :disabled="!scope.row.scale.is_main"
      :open-delay="500"
    >
      <el-switch
        v-model="scope.row.scale.is_main"
        :disabled="!isFieldAvailableForEdit(scope.row, 'scale.is_main')"
        :inactive-value="false"
        :active-value="true"
        @change="saveElementPropChange(scope.row, 'scale', {is_main:$event})"
      >
      </el-switch>
    </el-tooltip>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
export default {
  name: 'astra-top-element-is-main-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
